var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeIcon = function SvgEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667185",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1.667 6.667S5.398 2.5 10.001 2.5s8.333 4.167 8.333 4.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#667185",
    strokeWidth: 1.5,
    d: "M17.953 10.87c.253.356.38.533.38.796s-.127.44-.38.796C16.814 14.06 13.907 17.5 9.999 17.5s-6.815-3.441-7.953-5.038c-.253-.355-.38-.533-.38-.796s.127-.44.38-.796C3.184 9.275 6.092 5.834 10 5.834s6.815 3.441 7.954 5.038Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#667185",
    strokeWidth: 1.5,
    d: "M12.5 11.667a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
  })));
};
export default SvgEyeIcon;